const quoteData = {
  meta: {
    title: "Rollbusch Quality Meats — 5 Page Website Quote",
    clientName: "Rollbusch Quality Meats",
    url: "https://rollbuschqualitymeats.com.au",
    date: "2025-11-26",
    quoteNumber: "Q-2025-RQM",
    preparedBy: "Jason Toomer",
    summary: [
      "A 5 page, mobile-first website that showcases three award-winning butcher stores and the Rollbusch abattoir in one place.",
      "Home page with an interactive store selector, opening hours and maps, plus awards and Google reviews to build trust.",
      "Clear structure for future expansion to an online shop, without adding store backend complexity in this phase."
    ]
  },

  business: {
    name: "2merative",
    abn: "61775724636",
    email: "hello@2merative.com",
    phone: "0498 135 744"
  },

  options: [
    {
      label: "5 page brochure site with store selector and awards showcase",
      sections: {
        projectApproach: [
          // Overall structure
          "Mobile-first build that looks great on phones, then scales up for tablets and desktops.",
          "Header with central logo and navigation links. Header hides on scroll down and reappears when scrolling stops, so content stays front and centre while keeping navigation easy.",
          "Footer with Rollbusch logo, key links, and social media icons so customers can easily find you on Facebook / Instagram.",
          "Navigation includes: Home, About, Awards, Contact, and an Online Shop placeholder link for future use (not active yet).",

          // Home page
          "Home page hero with a unique store selector. Four tabs in the hero for each location: Store 1, Store 2, Store 3, and the Abattoir.",
          "Each hero tab shows location-specific content in-place: short intro, address, opening hours, and a mini highlights list.",
          "Store-specific Google Maps embed for each tab or store section so customers can quickly see where each outlet is located.",
          "Opening times and key details (phone, address, parking notes) clearly listed for each store.",
          "Dedicated Awards strip on the home page, highlighting that Rollbusch are award-winning smallgoods producers.",
          "Interactive Awards section on the home page that allows visitors to browse award wins (by year, category, or product), with images of trophies and certificates where supplied.",
          "Google reviews showcase pulled from your existing profiles. We will embed a reviews widget or curated screenshots so visitors see social proof immediately.",
          "Clear call-to-action blocks such as “Find your nearest store”, “View our awards”, and “Contact us for orders and catering”.",

          // About page
          "About page that tells the Rollbusch story. Focus on history, family ownership, the abattoir, and commitment to quality and animal welfare.",
          "Section for photos of the team, the farm, and in-store displays so customers connect with the people behind the brand.",
          "Optional timeline or milestones for key award wins and business milestones if you provide dates.",

          // Awards page
          "Dedicated Awards page linked from the home page and navigation, showcasing smallgoods and other awards in more detail.",
          "Awards grouped by year and/or competition, with product names and any available photos of trophies, certificates, or events.",
          "Optional filters (e.g. All, Smallgoods, Sausages, Bacon, etc.) depending on the number of awards you provide.",
          "Space to add new awards in future without redesigning the page layout.",

          // Contact page + form security
          "Contact page with a simple enquiry form powered by Formspree, plus contact details for each store.",
          "Form fields to include: name, email, phone, message, and a dropdown for which store the enquiry relates to (or general).",
          "Form submits via HTTPS to Formspree. No database is required on your hosting; Formspree securely stores the submission and forwards it by email.",
          "We configure Formspree with domain restrictions so that only submissions coming from rollbuschqualitymeats.com.au are accepted, reducing the risk of abuse.",
          "Email addresses are not printed in full on the page, which reduces email scraping and spam.",
          "We add a hidden honeypot field to help filter out bots and can add basic rate-limiting or CAPTCHA if needed.",
          "If you prefer an extra layer of security later, we can add a lightweight backend relay on your hosting that checks the request origin before forwarding to Formspree. This keeps your Formspree project ID and recipient details hidden from the browser.",

          // Future online shop placeholder
          "Navigation includes an “Online Shop (coming soon)” link that can later be wired up to Shopify or WooCommerce without changing the rest of the site.",
          "The shop link will currently point to a simple holding page or modal explaining that online ordering is coming soon and that customers can call or visit in person.",

          // Technical / SEO / performance
          "Built using a modern front-end stack suitable for your hosting environment, keeping the site fast and maintainable.",
          "Basic SEO on each page. Title, meta description, and open graph tags for better display in search and social sharing.",
          "Performance basics such as optimised images, lazy loading where suitable, and clean code to keep the site fast.",
          "We set up Google Analytics or GA4 tracking if you provide access, so you can see how customers find and use the site.",
          "Brand colours and fonts matched closely to your existing Rollbusch branding (store signage, packaging, and logo).",

          // Content responsibilities
          "You provide the final logo files, store photos, award details, and copy (we can help refine text for clarity and flow).",
          "We will perform light edits for spelling, grammar, and structure so the content reads professionally."
        ],

        oneOff: [
          { item: "5 page website build including store selector, awards showcase, Google reviews, and mobile-first layout", cost: 3000 },
          { item: "First year hosting, SSL, backups and basic monitoring", cost: 220 }
        ],

        recurring: [
          { item: "Annual hosting. SSL certificate renewal. Backups. Basic uptime monitoring", costMonthly: 0, costYearly: 220 }
        ]
      }
    }
  ],

  gstRate: 0.1,

  totals: {
    // Convenience snapshot for UI if you display a headline number
    subtotalExGst: 3220,
    gst: 322,
    totalIncGst: 3542
  },

  notes: [
    "This quote covers a 5 page brochure-style site with store selector, awards, reviews, and a secure contact form. An online shop is not included in this phase.",
    "We will need access to your domain and hosting to deploy the site and configure SSL.",
    "You provide images, logo files, copy, award details, and links to your Google profiles and social media. Stock image purchase is out of scope.",
    "Form submissions will be handled by Formspree. They manage storage and delivery securely; we do not run or maintain a mail server for this.",
    "If you would like us to later add an online shop (Shopify or WooCommerce), we can provide a separate quote once the functional requirements are clear."
  ],

  assumptionsExclusions: [
    "Complex ticketing, memberships, loyalty programs, or online ordering systems are not included.",
    "Online shop build, product photography, and content writing beyond light edits are not included.",
    "Third party paid services, apps, or plugins (beyond Formspree’s free tier) are not included.",
    "Email mailbox setup and ongoing email costs are not included.",
    "Signage, printed collateral, and social media management are out of scope for this quote."
  ],

  warrantySupport: [
    "30 day warranty for issues related to this build after launch, covering bugs or layout problems we introduce.",
    "Further enhancements or content changes are available at $100 per hour.",
    "Major new features (such as a full online shop) will be quoted separately before any work starts."
  ],

  acceptance: [
    "Valid until 2025-12-10.",
    "Payment terms: 50% on acceptance and 50% on launch.",
    "Work will be scheduled once the initial payment is received and all required content (logo, copy, images) is provided."
  ]
};

export { quoteData };
export default quoteData;
